import { useLocalization } from "../../hooks/useLocalization";

export const SkipLink = () => {
  const { strings } = useLocalization();

  return (
    <a
      href="#main-content"
      className="absolute top-3 left-3 z-[10000] rounded-small bg-light-blue px-4 py-[0.65rem] font-jetbrains text-[0.875rem] font-semibold text-page no-underline -translate-y-[200%] transition-transform duration-200 ease-in-out focus:translate-y-0 focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-white focus-visible:translate-y-0"
    >
      {strings.COMMON.SKIP_TO_CONTENT}
    </a>
  );
};
